export const isItchBuild = process.env.REACT_APP_ITCH_BUILD === 'true';

export function returnToMainMenu(): void {
  // On itch the page lives at a nested CDN path inside an iframe; navigating to '/'
  // would leave the game. Reload our own index.html without the session_id query
  // (a fresh game) instead.
  window.location.href = isItchBuild ? window.location.pathname : '/';
}
